import { render, staticRenderFns } from "./NoConcepts.vue?vue&type=template&id=7bc8886c&scoped=true"
import script from "./NoConcepts.vue?vue&type=script&lang=js"
export * from "./NoConcepts.vue?vue&type=script&lang=js"
import style0 from "./NoConcepts.vue?vue&type=style&index=0&id=7bc8886c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc8886c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/.pnpm/vuetify-loader@1.7.3_uhb5aaqqgawn4pxsnzso5z623i/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
